export default "__VITE_ASSET__31b92edc__"